import { useEffect, useState } from "react";

const DEFAULT_DELAY = 500;

export const useDebounce = <T = any>(value: T, delay = DEFAULT_DELAY) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
